/**
 * Script pour déplacer le sélecteur de langue WPML dans la modale du menu sur mobile.
 */
function moveLanguageSwitcher() {
	const languageSwitcher = document.querySelector('.wpml-language-switcher-block');
	const modalContent = document.querySelector('#modal-1-content');
	if (languageSwitcher && modalContent) {
		if (window.innerWidth <= 880) { // Seulement en mobile
			modalContent.appendChild(languageSwitcher.style.display = 'block');
		}
	}
}

// Exécuter au chargement et au redimensionnement
document.addEventListener('DOMContentLoaded', moveLanguageSwitcher);
window.addEventListener('resize', moveLanguageSwitcher);
